module.exports = __webpack_public_path__ + "media/images/steps/step_1-697bac22d3d3584db6f1292ee0ae874a.svg";